import { ScaleQuantize } from 'd3-scale';

import { buildColorRule } from '../../../core/color-rule/builder.js';
import { useChartLayoutOrientation } from '../../../core/components/chart-layout/hooks/useChartLayoutOrientation.js';
import { getLegendOrientation } from '../../../core/components/chart-layout/utils/orientation.js';
import { RangeLegend } from '../../../core/components/legend/range/RangeLegend.js';
import { RangeItem } from '../../../core/components/legend/range/types/range-legend.js';
import { useColorRuleConfig } from '../../../core/context/ColorRuleContext.js';
import { ColoredRange } from '../../../core/types/colored-range.js';
import { buildLegendItemsFromRange } from '../../../core/utils/build-legend-items-from-range.js';
import { buildQuantizedRangeItems } from '../../../core/utils/build-quantized-range-items.js';
import { isValidColorPalette } from '../../../core/utils/is-valid-color-palette.js';
import { useHoneycombBaseScale } from '../../hooks/use-honeycomb-base-scale.js';
import { useHoneycombFilteredColorScheme } from '../../hooks/use-honeycomb-filtered-color-scheme.js';
import { useHoneycombTickFormatter } from '../../hooks/use-honeycomb-tick-formatter.js';

export const HoneycombRangeLegendRenderer = () => {
  const { orientation: layoutOrientation } = useChartLayoutOrientation();
  const colorScheme = useHoneycombFilteredColorScheme();
  const orientation = getLegendOrientation(layoutOrientation);
  const scale = useHoneycombBaseScale();
  const formatter = useHoneycombTickFormatter();
  const colorRules = useColorRuleConfig();

  let items: RangeItem[] = [];

  if (isValidColorPalette(colorScheme)) {
    items = buildQuantizedRangeItems(scale as ScaleQuantize<string>, true);
  } else {
    const range = colorScheme as ColoredRange[];
    const rangeItems = [...range];
    items = buildLegendItemsFromRange(rangeItems);
  }
  const colorRule = buildColorRule(colorRules)(items, 'numericalLegend');
  const itemsWithColor = items.map((item) => ({
    ...item,
    color: colorRule.for(item)?.Default ?? item.color,
  }));

  return (
    <RangeLegend
      items={itemsWithColor}
      orientation={orientation}
      formatter={formatter}
    />
  );
};
